import React from 'react'
import {
    CtaButton,
    GridColumn,
    GridRow,
    ImageTextListComponent,
    ImageTextCTABlock,
    AccordionComponent,
    ThreeColumnText,
    PagePromotion,
    LoomGridCard,
} from '.'
import { Headline } from './headline'
import { Media } from './media'
import { RichText } from './richText'
import { UmbracoForm } from './umbracoForm'
import { Embed } from './embed'

import './grid.scss'
import { GridDivider } from './divider'

const GridTypes = {
    rte: RichText,
    threeColumnText: ThreeColumnText,
    pagePromotion: PagePromotion,
    headline: Headline,
    umbraco_form_picker: UmbracoForm,
    media: Media,
    listOfImageTextAndDivider: ImageTextListComponent,
    divider: GridDivider,
    ctaButton: CtaButton,
    imageTextCTABlock: ImageTextCTABlock,
    embed: Embed,
    accordion: AccordionComponent,
    loomContactCard: LoomGridCard,
}

export interface GridProps {
    rows: GridRow[]
}

export const Grid: React.FC<GridProps> = props => {
    if (props.rows && props.rows.length > 0 && typeof props.rows != 'string')
        return (
            <div className="grid">
                {props.rows.map((row, index) => (
                    <GridRowComponent key={'grid-row-' + index} {...row} />
                ))}
            </div>
        )
    return null
}

export const GridRowComponent: React.FC<GridRow> = props => {
    if (props.columns && props.columns.length > 0) {
        const gridTemplateColumns = props.columns.map(c => c.size + 'fr').join(' ')
        const rowClasses = ['grid-row no-bottom-spacing']

        if (props.config) {
            rowClasses.push(...Object.values(props.config))
        }

        return (
            <div
                className={rowClasses.join(' ')}
                style={{ gridTemplateColumns: gridTemplateColumns }}
            >
                {props.columns.map((column, index) => {
                    const colClasses = ['grid-column']

                    if (column.config) {
                        colClasses.push(...Object.values(column.config))
                    }

                    return (
                        <div className={colClasses.join(' ')} key={'grid-column-' + index}>
                            <GridElementsComponent {...column} />
                        </div>
                    )
                })}
            </div>
        )
    }
    return null
}

export const GridElementsComponent: React.FC<GridColumn> = props => {
    if (props.elements && props.elements.length > 0)
        return (
            <>
                {props.elements.map(
                    (element, index) =>
                        GridTypes[element.type] &&
                        React.createElement(GridTypes[element.type], { key: 'grid-element-' + index, ...element })
                )}
            </>
        )
    return null
}
